function Loader() {
    return (
        <div style={styles.overlay}>
            <div style={styles.loaderContainer}>
                <img
                    src="/open-book.gif"
                    alt="Loading..."
                    style={styles.gifImage}
                />
                <p style={styles.loadingText}>Loading...</p>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(8px)',
        zIndex: 10050
    },
    loaderContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px'
    },
    gifImage: {
        width: '100px',
        height: '100px',
        objectFit: 'contain'
    },
    loadingText: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#0e2b51',
        margin: 0,
        fontFamily: "'Hind Mysuru', sans-serif"
    }
};

export default Loader;